import { render, staticRenderFns } from "./settings-account-change.vue?vue&type=template&id=3aee1743&"
import script from "./settings-account-change.vue?vue&type=script&lang=js&"
export * from "./settings-account-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports